import { useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import { selectHealingStats } from '../../../redux/locatorDrift/locatorDriftSlice';
import MetricCard from '../shared/MetricCard';
import { healingStatColors } from './healingStyles';

export default function HealingStats() {
  const stats = useSelector(selectHealingStats) || {};
  const cards = [
    ['Total Failures', stats.total || 0, healingStatColors.total],
    ['Pending', stats.pending || 0, healingStatColors.pending],
    ['Accepted', stats.accepted || 0, healingStatColors.accepted],
    ['Rejected', stats.rejected || 0, healingStatColors.rejected],
    ['Auto-Healed', stats.auto_healed || 0, healingStatColors.autoHealed],
    ['Unconfirmed', stats.auto_unconfirmed || 0, healingStatColors.autoUnconfirmed],
  ];

  return (
    <Grid container spacing={1.5}>
      {cards.map(([label, value, color]) => (
        <Grid item xs={12} sm={6} md={2} key={label}>
          <MetricCard label={label} value={value} color={color} />
        </Grid>
      ))}
    </Grid>
  );
}
